import { combineReducers } from '@reduxjs/toolkit'
import view from './viewSlice'
import modal from './modalSlice'

const reducer = combineReducers({
    view,
    modal
})

export default reducer